interface EcommerceData {
  [key: string]: any; // Define a flexible structure for ecommerce data
}

interface PushData {
  ecommerce?: EcommerceData;
}

const get = (): any[] => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  } else {
    return []; // Return an empty array when on the server
  }
};

/**
 * This function register events in GTM, for more information https://developers.google.com/tag-manager/devguide?hl=es
 * @param {String} event name of the event that you want register in GTM
 * @param {Object} data
 * @param {Object} data.ecommerce
 *
 */

const push = (event: string, { ecommerce }: PushData = {}): void => {
  let dataLayer = get();

  // Declare body with a flexible type, allowing optional ecommerce property
  let body: { event: string; ecommerce?: EcommerceData } = {
    event,
  };

  if (typeof ecommerce === "object" && Object.keys(ecommerce).length) {
    body.ecommerce = ecommerce;
  }

  dataLayer.push(body);
};

const dataLayer = {
  get,
  push,
};

export default dataLayer;
